import authService from "@/lib/auth";
import { registerForPushNotificationsAsync } from "@/lib/registerForPushNotificationsAsync";
import { useAuthStore } from "@/stores/use-auth-store";
import * as Device from "expo-device";
import { Platform } from "react-native";

export async function syncPushTokenWithServer(options?: {
  requestPermission?: boolean;
}): Promise<string | null> {
  if (Platform.OS === "web" || !Device.isDevice) {
    return null;
  }

  const { token, user, setUser } = useAuthStore.getState();
  if (!token || !user) {
    return null;
  }

  try {
    const localToken = await registerForPushNotificationsAsync({
      requestPermission: options?.requestPermission ?? false,
    });

    if (!localToken) {
      return null;
    }

    if (user.fcm_token === localToken) {
      return localToken;
    }

    const { fcm_token } = await authService.deviceToken({ fcm_token: localToken });
    setUser({ ...useAuthStore.getState().user!, fcm_token });

    return fcm_token;
  } catch (error) {
    console.warn("Push token sync failed", error);
    return null;
  }
}
